module.exports = __webpack_public_path__ + "home_data_enhanced.8b607d46d5e5b245b594.png";


//////////////////
// WEBPACK FOOTER
// /Users/ranjith/eclipse-workspace/monarch-web-contentful/src/assets/img/home_data_enhanced.png
// module id = ../../../../../src/assets/img/home_data_enhanced.png
// module chunks = styles